import type { PeriodFormat, PeriodData } from "./types";

export const getPeriodData = (format: PeriodFormat, offset: number): PeriodData => {
  if (format === "week") {
    if (offset === 0) {
      return {
        title: "5 — 11 сентября 2026",
        data: [
          { date: "05.09", spent: 12400, clicks: 680, impressions: 10450, ctr: 6.5, conversions: 38, cpa: 326 },
          { date: "06.09", spent: 13100, clicks: 710, impressions: 11200, ctr: 6.3, conversions: 42, cpa: 312 },
          { date: "07.09", spent: 14200, clicks: 780, impressions: 12100, ctr: 6.4, conversions: 46, cpa: 308 },
          { date: "08.09", spent: 13800, clicks: 740, impressions: 11800, ctr: 6.3, conversions: 44, cpa: 313 },
          { date: "09.09", spent: 14500, clicks: 810, impressions: 12600, ctr: 6.4, conversions: 47, cpa: 308 },
          { date: "10.09", spent: 15100, clicks: 890, impressions: 13400, ctr: 6.6, conversions: 51, cpa: 296 },
          { date: "11.09", spent: 15300, clicks: 920, impressions: 13900, ctr: 6.6, conversions: 54, cpa: 283 },
        ],
      };
    }
    if (offset === -1) {
      return {
        title: "29 августа — 4 сентября 2026",
        data: [
          { date: "29.08", spent: 11800, clicks: 640, impressions: 9800, ctr: 6.5, conversions: 35, cpa: 337 },
          { date: "30.08", spent: 12200, clicks: 660, impressions: 10100, ctr: 6.5, conversions: 37, cpa: 329 },
          { date: "31.08", spent: 12900, clicks: 690, impressions: 10600, ctr: 6.5, conversions: 39, cpa: 330 },
          { date: "01.09", spent: 13500, clicks: 720, impressions: 11200, ctr: 6.4, conversions: 41, cpa: 329 },
          { date: "02.09", spent: 13200, clicks: 700, impressions: 10900, ctr: 6.4, conversions: 40, cpa: 330 },
          { date: "03.09", spent: 13800, clicks: 730, impressions: 11400, ctr: 6.4, conversions: 43, cpa: 320 },
          { date: "04.09", spent: 14100, clicks: 750, impressions: 11700, ctr: 6.4, conversions: 44, cpa: 320 },
        ],
      };
    }
    return {
      title: `Неделя (${offset > 0 ? `+${offset}` : offset})`,
      data: [
        { date: "Пн", spent: 12000, clicks: 650, impressions: 10000, ctr: 6.5, conversions: 36, cpa: 333 },
        { date: "Вт", spent: 12500, clicks: 680, impressions: 10500, ctr: 6.5, conversions: 38, cpa: 328 },
        { date: "Ср", spent: 13000, clicks: 710, impressions: 11000, ctr: 6.5, conversions: 40, cpa: 325 },
        { date: "Чт", spent: 13500, clicks: 730, impressions: 11300, ctr: 6.5, conversions: 41, cpa: 329 },
        { date: "Пт", spent: 14000, clicks: 760, impressions: 11800, ctr: 6.4, conversions: 43, cpa: 325 },
        { date: "Сб", spent: 14500, clicks: 800, impressions: 12400, ctr: 6.5, conversions: 46, cpa: 315 },
        { date: "Вс", spent: 15000, clicks: 840, impressions: 13000, ctr: 6.5, conversions: 49, cpa: 306 },
      ],
    };
  }

  if (format === "month") {
    const monthNames = [
      "Май 2026",
      "Июнь 2026",
      "Июль 2026",
      "Август 2026",
      "Сентябрь 2026",
      "Октябрь 2026",
    ];
    const baseIdx = 4;
    const idx = Math.max(0, Math.min(monthNames.length - 1, baseIdx + offset));
    return {
      title: monthNames[idx] ?? `Месяц (${offset})`,
      data: [
        { date: "1–7 число", spent: 88000, clicks: 4800, impressions: 74000, ctr: 6.5, conversions: 270, cpa: 325 },
        { date: "8–14 число", spent: 96000, clicks: 5200, impressions: 81000, ctr: 6.4, conversions: 305, cpa: 314 },
        { date: "15–21 число", spent: 94000, clicks: 5100, impressions: 79000, ctr: 6.5, conversions: 295, cpa: 318 },
        { date: "22–28 число", spent: 99000, clicks: 5500, impressions: 84000, ctr: 6.5, conversions: 320, cpa: 309 },
        { date: "29–31 число", spent: 42000, clicks: 2300, impressions: 36000, ctr: 6.4, conversions: 135, cpa: 311 },
      ],
    };
  }

  const yearVal = 2026 + offset;
  return {
    title: `${yearVal} год`,
    data: [
      { date: "Янв", spent: 340000, clicks: 18500, impressions: 285000, ctr: 6.5, conversions: 1040, cpa: 326 },
      { date: "Фев", spent: 360000, clicks: 19800, impressions: 305000, ctr: 6.5, conversions: 1120, cpa: 321 },
      { date: "Мар", spent: 390000, clicks: 21500, impressions: 330000, ctr: 6.5, conversions: 1230, cpa: 317 },
      { date: "Апр", spent: 380000, clicks: 20900, impressions: 320000, ctr: 6.5, conversions: 1190, cpa: 319 },
      { date: "Май", spent: 410000, clicks: 22800, impressions: 350000, ctr: 6.5, conversions: 1310, cpa: 313 },
      { date: "Июн", spent: 400000, clicks: 22200, impressions: 340000, ctr: 6.5, conversions: 1280, cpa: 312 },
      { date: "Июл", spent: 415000, clicks: 23100, impressions: 355000, ctr: 6.5, conversions: 1340, cpa: 309 },
      { date: "Авг", spent: 430000, clicks: 24200, impressions: 370000, ctr: 6.5, conversions: 1410, cpa: 305 },
      { date: "Сен", spent: 420000, clicks: 23600, impressions: 362000, ctr: 6.5, conversions: 1380, cpa: 304 },
    ],
  };
};
